import React from 'react';
import {
  AppBar,
  Box,
  IconButton,
  TextField,
  Toolbar,
  ToggleButton,
  ToggleButtonGroup,
  InputAdornment,
} from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import SearchIcon from '@mui/icons-material/Search';
import ClearIcon from '@mui/icons-material/Clear';
import ViewModuleIcon from '@mui/icons-material/ViewModule';
import ViewAgendaIcon from '@mui/icons-material/ViewAgenda';

export default function MobileTopBar(props: {
  onOpenDrawer: () => void;
  searchTerm: string;
  onSearchTermChange: (value: string) => void;
  columns: 1 | 2;
  onColumnsChange: (cols: 1 | 2) => void;
}) {
  const {
    onOpenDrawer,
    searchTerm,
    onSearchTermChange,
    columns,
    onColumnsChange,
  } = props;

  return (
    <AppBar position="sticky" sx={{ top: 0 }}>
      <Toolbar sx={{ gap: 1 }}>
        <IconButton color="inherit" edge="start" onClick={onOpenDrawer} aria-label="Öppna kategorier">
          <MenuIcon />
        </IconButton>

        <Box sx={{ flex: 1, minWidth: 0 }}>
          <TextField
            value={searchTerm}
            onChange={(e) => onSearchTermChange(e.target.value)}
            placeholder="Sök…"
            size="small"
            fullWidth
            variant="outlined"
            sx={{
              bgcolor: 'white',
              borderRadius: 1,
              '& .MuiOutlinedInput-root': {
                height: 38,
              },
            }}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon fontSize="small" />
                </InputAdornment>
              ),
              endAdornment: searchTerm ? (
                <InputAdornment position="end">
                  <IconButton
                    size="small"
                    aria-label="Rensa sök"
                    onClick={() => onSearchTermChange('')}
                    edge="end"
                  >
                    <ClearIcon fontSize="small" />
                  </IconButton>
                </InputAdornment>
              ) : undefined,
            }}
          />
        </Box>

        <ToggleButtonGroup
          size="small"
          exclusive
          value={String(columns)}
          onChange={(_, v) => {
            if (!v) return;
            onColumnsChange(v === '1' ? 1 : 2);
          }}
          aria-label="Grid layout"
          sx={{ bgcolor: 'rgba(255,255,255,0.12)', borderRadius: 1 }}
        >
          <ToggleButton value="2" aria-label="2 per rad" sx={{ color: 'white', borderColor: 'rgba(255,255,255,0.25)' }}>
            <ViewModuleIcon fontSize="small" />
          </ToggleButton>
          <ToggleButton value="1" aria-label="1 per rad" sx={{ color: 'white', borderColor: 'rgba(255,255,255,0.25)' }}>
            <ViewAgendaIcon fontSize="small" />
          </ToggleButton>
        </ToggleButtonGroup>
      </Toolbar>
    </AppBar>
  );
}

